import {GlobalState} from "./global-state";

export const GlobalResizeState = ({translate=v=>v, next}) => GlobalState({
    translate,
    eventName: "resize",
    defaultValue: {width: 1024, height: 768},
    getValue: () => ({
        width : window.innerWidth ,
        height: window.innerHeight,
    }),
    next,
});

